import React from 'react';
import styled from 'styled-components';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import { translate } from '../../Services/translation';
import { fontFamilyBold, header } from '../../styling/mixins/typography';

interface ProductListingTitleProps {
    name: string;
}

const ProductListingTitle = styled.div`
    display: flex;
    gap: 1.6rem;
    & > span {
        ${header('h1')}
        ${fontFamilyBold};
        text-transform: uppercase;
        margin-bottom: 0.8rem;
    }
`

const ProductListingTitleComponent = (category: ProductListingTitleProps) => {
    const filteredBrands = useTypedSelector((state) => {
        var selectedBrands = state.productFiltering.filters.find(x => x.id == "Brand")?.selectedOptions
        return selectedBrands
    });

    return (
        <ProductListingTitle>
            <span>
            {filteredBrands && filteredBrands.length < 3 ? filteredBrands.map((x, idx) => (
                <>{x}{filteredBrands.length > 1 && filteredBrands.length > (idx+1) ? ", " : " "}</>
            )) : 
                <>{filteredBrands ? <>{filteredBrands.length} {translate("product-listing.multiple-selected-brands")} </> : ""}</>
            }
             {category.name}
            </span>
        </ProductListingTitle>
    );
};

export default ProductListingTitleComponent;
